import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Flex,
  HStack,
  Image,
  Img,
  InputGroup,
  InputRightElement,
  Skeleton,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { formatTableValue } from "./formatTable";
import calendarIcon from "../../assets/images/onleave/calendar.svg";
import DatePicker from "react-datepicker";
import { useTab } from "../../contexts/useTab";
import SearchableSelect from "../../components/selectForm";
import { useReport } from "../../hooks/useReport";
import { useCategories } from "../../categorys/statement/cateStatement";
import chevronLeft from "../../assets/images/employee/chevron-left.svg";
import chevronRight from "../../assets/images/employee/chevron-right.svg";
import ReactPaginate from "react-paginate";
// import { useGetTotalReport } from "../../hooks/useGetTotalReport";
import {
  customDateFormatType3,
  formatNumber,
  restoreDateFromFormatted,
} from "../../utils/utils";
import { Link, useLocation, useNavigate } from "react-router-dom";

const TableStatement = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const {
    employeeId: employeeIdParam,
    saleAreaId: saleAreaIdParam,
    saleBlockId: saleBlockIdParam,
    branchId: branchIdParam,
    projectId: projectIdParam,
    startTime: startTimeParam,
    endTime: endTimeParam,
  } = location.state || {};

  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [projectId, setProjectId] = useState(null);
  const [saleAreaId, setSaleAreaId] = useState(null);
  const [saleBlockId, setSaleBlockId] = useState(null);
  const [branchId, setBranchId] = useState(null);
  const [employeeId, setEmployeeId] = useState(null);
  const [shouldFetch, setShouldFetch] = useState(false);

  const { statementTab, setStatementTab } = useTab();

  const tabInfo = [
    {
      title: "Cá nhân",
      content: 0,
    },
    {
      title: "Vùng",
      content: 1,
    },
    {
      title: "Khối",
      content: 2,
    },
    {
      title: "Đại lý",
      content: 3,
    },
  ];

  const {
    reportData,
    getTotalReportData,
    isLoading,
    isRefetching,
    refetch,
    totalPages,
    setCurrentPage,
    currentPage,
    entries,
    startEntry,
    endEntry,
  } = useReport(
    statementTab + 1,
    projectId,
    saleAreaId,
    saleBlockId,
    branchId,
    employeeId,
    startDate,
    endDate
  );

  const tableData = {
    headers: [
      {
        label:
          statementTab === 0
            ? "Mã NV"
            : statementTab === 1
            ? "Mã vùng"
            : statementTab === 3
            ? "Mã đại lý"
            : "Mã khối",
        key: "code",
      },
      {
        label:
          statementTab === 0
            ? "Tên nhân viên"
            : statementTab === 1
            ? "Tên vùng"
            : statementTab === 3
            ? "Tên đại lý"
            : "Tên khối",
        key: "name",
      },
      {
        label: "Mã vùng",
        key: "saleAreaCode",
      },
      {
        label: "Tên vùng",
        key: "saleAreaName",
      },
      {
        label: "Mã khối",
        key: "saleBlockCode",
      },
      {
        label: "Tên khối",
        key: "saleBlockName",
      },
      {
        label: "Số booking",
        key: "totalBooking",
      },
      {
        label: "Số booking đã duyệt",
        key: "totalBookingApproved",
      },
      {
        label: "Số locking",
        key: "totalLocking",
      },
      {
        label: "Số locking đã duyệt",
        key: "totalLockingApproved",
      },
      {
        label: "Doanh số locking đã duyệt",
        key: "totalLockingApartmentValueApproved",
      },
      {
        label: "Số TTKQ",
        key: "totalLocking",
      },
      {
        label: "Số TTKQ đã duyệt",
        key: "totalTtkqApproved",
      },
      {
        label: "Số HĐMB",
        key: "totalContract",
      },
      {
        label: "Số HĐMB đã duyệt",
        key: "totalContractApproved",
      },
      // {
      //   label: "Doanh số booking",
      //   key: "totalBookingAmount",
      // },
      // {
      //   label: "Doanh số booking đã duyệt",
      //   key: "totalBookingAmountApproved",
      // },
      // {
      //   label: "Doanh số locking đã duyệt",
      //   key: "totalLockingApartmentValueApproved",
      // },

      // {
      //   label: "Doanh số TTKQ",
      //   key: "totalTtkqAmount",
      // },
      // {
      //   label: "Doanh số TTKQ đã duyệt",
      //   key: "totalTtkqAmountApproved",
      // },

      // {
      //   label: "Doanh số HĐMB",
      //   key: "totalContractAmount",
      // },
      // {
      //   label: "Doanh số HĐMB đã duyệt",
      //   key: "totalContractAmountApproved",
      // },
    ],
    data: reportData,
  };

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
    refetch();
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldFetch(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (startTimeParam || endTimeParam) {
      const startTimeData = startTimeParam ? new Date(startTimeParam) : null;
      const endTimeData = endTimeParam ? new Date(endTimeParam) : null;
      setDateRange([startTimeData, endTimeData]);
    }
  }, [startTimeParam, endTimeParam]);

  const { constantData } = useCategories(shouldFetch);

  const formatEntries = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({
      key,
      value:
        typeof value === "object"
          ? value.fullName || JSON.stringify(value)
          : value,
    }));

  const projects = useMemo(
    () => formatEntries(constantData?.project),
    [constantData?.project]
  );

  const saleAreas = useMemo(
    () => formatEntries(constantData?.saleAreas),
    [constantData?.saleAreas]
  );

  const saleBlocks = useMemo(
    () => formatEntries(constantData?.saleBlocks),
    [constantData?.saleBlocks]
  );

  const branchs = useMemo(
    () => formatEntries(constantData?.branches),
    [constantData?.branches]
  );

  const employees = useMemo(
    () => formatEntries(constantData?.employee),
    [constantData?.employee]
  );

  const setInfoTabData = (index) => {
    setStatementTab(index);
  };

  const getLockingStatementUrl = (id, saleArea, saleBlock, status) => {
    let search = "";

    if (startDate) {
      const startTime = customDateFormatType3(startDate);
      search += `&startTime=${startTime}`;
    }

    if (endDate) {
      const endTime = customDateFormatType3(endDate);
      search += `&endTime=${endTime}`;
    }

    if (projectId) search += `&projectId=${projectId}`;
    if (saleAreaId) search += `&saleAreaId=${saleAreaId}`;
    if (saleBlockId) search += `&saleBlockId=${saleBlockId}`;
    if (branchId) search += `&branchId=${branchId}`;
    if (employeeId) search += `&employeeId=${employeeId}`;

    let base = "";

    if (statementTab + 1 === 3) {
      base = `/locking-statement?saleBlock=${
        saleBlock || "null"
      }&status=${status}`;
    } else if (statementTab + 1 === 2) {
      base = `/locking-statement?saleArea=${
        saleArea || "null"
      }&status=${status}`;
    } else if (statementTab + 1 === 1) {
      base = `/locking-statement?employee=${id || ""}&status=${status}`;
    } else {
      base = `/locking-statement?agentId=${id || ""}&status=${status}`;
    }

    return `${base}${search}`;
  };

  const getBookingStatementUrl = (id, saleArea, saleBlock, status) => {
    let search = "";

    if (startDate) {
      const startTime = customDateFormatType3(startDate);
      search += `&startTime=${startTime}`;
    }

    if (endDate) {
      const endTime = customDateFormatType3(endDate);
      search += `&endTime=${endTime}`;
    }

    if (projectId) search += `&projectId=${projectId}`;
    if (saleAreaId) search += `&saleAreaId=${saleAreaId}`;
    if (saleBlockId) search += `&saleBlockId=${saleBlockId}`;
    if (branchId) search += `&branchId=${branchId}`;
    if (employeeId) search += `&employeeId=${employeeId}`;

    let base = "";

    if (statementTab + 1 === 3) {
      base = `/booking-statement?saleBlock=${
        saleBlock || "null"
      }&status=${status}`;
    } else if (statementTab + 1 === 2) {
      base = `/booking-statement?saleArea=${
        saleArea || "null"
      }&status=${status}`;
    } else if (statementTab + 1 === 1) {
      base = `/booking-statement?employee=${id || ""}&status=${status}`;
    } else {
      base = `/booking-statement?agentId=${id || ""}&status=${status}`;
    }

    return `${base}${search}`;
  };

  const getSaleContractStatementUrl = (id, saleArea, saleBlock, status) => {
    let search = "";

    if (startDate) {
      const startTime = customDateFormatType3(startDate);
      search += `&startTime=${startTime}`;
    }

    if (endDate) {
      const endTime = customDateFormatType3(endDate);
      search += `&endTime=${endTime}`;
    }

    if (projectId) search += `&projectId=${projectId}`;
    if (saleAreaId) search += `&saleAreaId=${saleAreaId}`;
    if (saleBlockId) search += `&saleBlockId=${saleBlockId}`;
    if (branchId) search += `&branchId=${branchId}`;
    if (employeeId) search += `&employeeId=${employeeId}`;

    let base = "";

    if (statementTab + 1 === 3) {
      base = `/sale-contract-statement?saleBlock=${
        saleBlock || "null"
      }&status=${status}`;
    } else if (statementTab + 1 === 2) {
      base = `/sale-contract-statement?saleArea=${
        saleArea || "null"
      }&status=${status}`;
    } else if (statementTab + 1 === 1) {
      base = `/sale-contract-statement?employee=${id || ""}&status=${status}`;
    } else {
      base = `/sale-contract-statement?agentId=${id || ""}&status=${status}`;
    }

    return `${base}${search}`;
  };

  const getTtkqStatementUrl = (id, saleArea, saleBlock, status) => {
    let search = "";

    if (startDate) {
      const startTime = customDateFormatType3(startDate);
      search += `&startTime=${startTime}`;
    }

    if (endDate) {
      const endTime = customDateFormatType3(endDate);
      search += `&endTime=${endTime}`;
    }

    if (projectId) search += `&projectId=${projectId}`;
    if (saleAreaId) search += `&saleAreaId=${saleAreaId}`;
    if (saleBlockId) search += `&saleBlockId=${saleBlockId}`;
    if (branchId) search += `&branchId=${branchId}`;
    if (employeeId) search += `&employeeId=${employeeId}`;

    let base = "";

    if (statementTab + 1 === 3) {
      base = `/ttkq-statement?saleBlock=${
        saleBlock || "null"
      }&status=${status}`;
    } else if (statementTab + 1 === 2) {
      base = `/ttkq-statement?saleArea=${saleArea || "null"}&status=${status}`;
    } else if (statementTab + 1 === 1) {
      base = `/ttkq-statement?employee=${id || ""}&status=${status}`;
    } else {
      base = `/ttkq-statement?agentId=${id || ""}&status=${status}`;
    }

    return `${base}${search}`;
  };

  return (
    <>
      <Flex gap={{ base: "16px" }}>
        <Box w={"75.36141636%"}>
          <Flex
            backgroundColor="var(--color-main)"
            borderRadius={{ base: "12px" }}
            flexDirection={"column"}
            minH={"80vh"}
          >
            <Box p={"16px 16px 12px 16px"}>
              <Flex
                alignItems={"flex-start"}
                justifyContent={"space-between"}
                gap={{ base: "16px" }}
                mt={"20px"}
                flexDirection={"column"}
              >
                <Flex
                  alignItems={"center"}
                  gap={{ base: "16px" }}
                  flex={"1"}
                  wrap="wrap"
                >
                  <Flex
                    alignItems={"center"}
                    p={"4px"}
                    bg={"var(--color-background-2)"}
                    w={{ base: "300px", xl: "503px" }}
                  >
                    {tabInfo.map((e, index) => {
                      return (
                        <Flex
                          alignItems={"center"}
                          justifyContent={"center"}
                          key={index}
                          flex={1}
                        >
                          <Flex
                            alignItems={"center"}
                            justifyContent={
                              index === 0 ? "flex-start" : "flex-end"
                            }
                            onClick={() => setInfoTabData(index)}
                            cursor={"pointer"}
                            zIndex={"10"}
                            flex={1}
                          >
                            <Flex
                              w={"100%"}
                              bg={
                                statementTab === index
                                  ? "var(--color-secondary)"
                                  : ""
                              }
                              justifyContent={"center"}
                              alignItems={"center"}
                              pt={"10px"}
                              pb={"9px"}
                              borderRadius={"6px"}
                            >
                              <Text
                                fontSize={{
                                  base: "14px",
                                }}
                                fontWeight={500}
                                lineHeight={"normal"}
                                fontFamily="var(--font-heading-main)"
                                color={
                                  statementTab === index
                                    ? "var(--color-main)"
                                    : "var(--color-black-5)"
                                }
                                textAlign={"center"}
                                whiteSpace="nowrap"
                              >
                                {e?.title}
                              </Text>
                            </Flex>
                          </Flex>
                          {index !== tabInfo.length - 1 &&
                            index !== statementTab && (
                              <Flex justifyContent={"flex-end"}>
                                <Box
                                  w={"1px"}
                                  h={"12px"}
                                  bg={"var(--color-black-2)"}
                                ></Box>
                              </Flex>
                            )}
                        </Flex>
                      );
                    })}
                  </Flex>
                  <InputGroup
                    w={"100%"}
                    maxW={{ base: "184px", xl: "200px" }}
                    zIndex={3}
                  >
                    <DatePicker
                      selectsRange={true}
                      startDate={startDate}
                      endDate={endDate}
                      dateFormat="dd/MM/yyyy"
                      locale="vi"
                      onChange={(update) => {
                        setDateRange(update);
                      }}
                      isClearable={true}
                      placeholderText="Từ ngày - Đến ngày"
                      className="datePickerStyle"
                    />
                    {!startDate && !endDate && (
                      <InputRightElement pointerEvents="none" h={"44px"}>
                        <Image src={calendarIcon} />
                      </InputRightElement>
                    )}
                  </InputGroup>
                  <SearchableSelect
                    width={{ base: "135px", xl: "200px" }}
                    isShowSearch={true}
                    options={projects}
                    // initialSelectedOptionParam={{ key: 0, value: "Chọn dự án" }}
                    initialSelectedOption={{ key: 0, value: "Chọn dự án" }}
                    setValue={setProjectId}
                  />
                  <SearchableSelect
                    width={{ base: "135px", xl: "200px" }}
                    isShowSearch={true}
                    options={saleAreas}
                    initialSelectedOption={{ key: 0, value: "Chọn vùng" }}
                    // initialSelectedOption={initialSelectedSaleArea}
                    setValue={setSaleAreaId}
                  />
                  <SearchableSelect
                    width={{ base: "135px", xl: "200px" }}
                    isShowSearch={true}
                    options={saleBlocks}
                    initialSelectedOption={{ key: 0, value: "Chọn khối" }}
                    // initialSelectedOption={initialSelectedSaleBlock}
                    setValue={setSaleBlockId}
                  />
                  <SearchableSelect
                    width={{ base: "135px", xl: "200px" }}
                    isShowSearch={true}
                    options={branchs}
                    initialSelectedOption={{
                      key: 0,
                      value: "Chọn chi nhánh",
                    }}
                    // initialSelectedOption={initialSelectedBranch}
                    setValue={setBranchId}
                  />
                  <SearchableSelect
                    width={{ base: "135px", xl: "200px" }}
                    isShowSearch={true}
                    options={employees}
                    initialSelectedOption={{
                      key: null,
                      value: "Tất cả nhân viên",
                    }}
                    // initialSelectedOption={initialSelectedEmployee}
                    setValue={setEmployeeId}
                  />
                </Flex>
              </Flex>
            </Box>

            <Box width={"100%"} height={"100%"}>
              <Skeleton isLoaded={!isLoading && !isRefetching}>
                <TableContainer
                  w={"100%"}
                  maxH="calc(100vh - 350.5px)"
                  overflowY="auto"
                >
                  <Table w={"100%"} variant="unstyled">
                    <Thead
                      position="sticky"
                      top="0"
                      zIndex="1"
                      w={"100%"}
                      h={"41px"}
                      color="white"
                      fontWeight="400"
                      backgroundColor="#F9FAFD"
                    >
                      <Tr h={{ base: "41px" }}>
                        {tableData.headers.map((e, index) => {
                          let width = "auto";
                          let textAlign = "auto";
                          if (
                            statementTab + 1 === 2 &&
                            e.key === "saleAreaCode"
                          ) {
                            return null;
                          }
                          if (
                            statementTab + 1 === 2 &&
                            e.key === "saleAreaName"
                          ) {
                            return null;
                          }
                          if (
                            (statementTab + 1 === 2 ||
                              statementTab + 1 === 3) &&
                            e.key === "saleBlockName"
                          ) {
                            return "";
                          }
                          if (
                            (statementTab + 1 === 2 ||
                              statementTab + 1 === 3) &&
                            e.key === "saleBlockCode"
                          ) {
                            return "";
                          }
                          if (e.key === "") {
                            width = "2%";
                            textAlign = "center";
                          } else if (e.key === "code") {
                            width = "5%";
                            textAlign = "start";
                          } else if (e.key === "name") {
                            width = "10%";
                            textAlign = "start";
                          } else if (e.key === "jobTitleName") {
                            width = "10%";
                            textAlign = "start";
                          } else if (e.key === "totalBooking") {
                            width = "10%";
                            textAlign = "start";
                          } else if (
                            e.key === "totalLockingApartmentValueApproved"
                          ) {
                            width = "10%";
                            textAlign = "start";
                          } else if (e.key === "saleAreaCode") {
                            width = "10%";
                            textAlign = "start";
                          } else if (e.key === "saleAreaName") {
                            width = "10%";
                            textAlign = "start";
                          } else if (e.key === "saleBlockName") {
                            width = "10%";
                            textAlign = "start";
                          } else if (e.key === "saleBlockCode") {
                            width = "10%";
                            textAlign = "start";
                          } else if (e.key === "totalBookingApproved") {
                            width = "10%";
                            textAlign = "start";
                          } else if (e.key === "totalLocking") {
                            width = "10%";
                            textAlign = "start";
                          } else if (e.key === "totalLockingApproved") {
                            width = "10%";
                            textAlign = "start";
                          } else if (e.key === "totalContract") {
                            width = "10%";
                            textAlign = "start";
                          } else if (e.key === "totalTtkqAmount") {
                            width = "10%";
                            textAlign = "start";
                          } else if (e.key === "totalTtkqAmountApproved") {
                            width = "10%";
                            textAlign = "start";
                          } else if (e.key === "totalContractAmount") {
                            width = "10%";
                            textAlign = "start";
                          } else if (e.key === "totalContractAmountApproved") {
                            width = "10%";
                            textAlign = "start";
                          } else if (e.key === "totalContractApproved") {
                            width = "10%";
                            textAlign = "start";
                          } else if (e.key === "totalTtkq") {
                            width = "10%";
                            textAlign = "start";
                          } else if (e.key === "totalTtkqApproved") {
                            width = "10%";
                            textAlign = "start";
                          } else if (
                            e.key === "timeDelivery" ||
                            e.key === "timeStart" ||
                            e.key === "timeEnd"
                          ) {
                            width = "5%";
                            textAlign = "end";
                          } else {
                            width = "10%";
                            textAlign = "end";
                          }
                          return (
                            <Td
                              p={"16px 16px 8px 8px"}
                              key={index}
                              border={"none"}
                              color={"#51607B"}
                              fontSize={{ base: "14px" }}
                              w={width}
                            >
                              <Box textAlign={"center"} fontWeight={"bold"}>{e.label}</Box>
                            </Td>
                          );
                        })}
                      </Tr>
                    </Thead>
                    <Tbody w={"100%"} h={"100%"}>
                      {tableData.data?.length > 0 ? (
                        tableData.data?.map((e, rowIndex) => {
                          const items = { ...e };
                          delete items.id;
                          delete items.saleBlockId;
                          delete items.saleAreaId;
                          const keyValues = Object.keys(items);
                          return (
                            <Tr key={rowIndex} h={"72px"}>
                              {keyValues.map((keyvalue, index) => {
                                let width = "auto";
                                let widthText = "100%";
                                let textAlign = "auto";
                                let whiteSpace = "inherit";

                                if (
                                  statementTab + 1 === 2 &&
                                  keyvalue === "saleAreaCode"
                                ) {
                                  return "";
                                }
                                if (
                                  statementTab + 1 === 2 &&
                                  keyvalue === "saleAreaName"
                                ) {
                                  return "";
                                }
                                if (
                                  (statementTab + 1 === 2 ||
                                    statementTab + 1 === 3) &&
                                  keyvalue === "saleBlockCode"
                                ) {
                                  return "";
                                }
                                if (
                                  (statementTab + 1 === 2 ||
                                    statementTab + 1 === 3) &&
                                  keyvalue === "saleBlockName"
                                ) {
                                  return "";
                                }

                                if (keyvalue === "") {
                                  width = "2%";
                                  textAlign = "center";
                                } else if (keyvalue === "code") {
                                  width = "5%";
                                  textAlign = "start";
                                } else if (keyvalue === "name") {
                                  width = "10%";
                                  textAlign = "start";
                                } else if (keyvalue === "jobTitleName") {
                                  width = "10%";
                                  textAlign = "start";
                                } else if (keyvalue === "totalBooking") {
                                  width = "10%";
                                  textAlign = "center";
                                } else if (
                                  keyvalue === "totalBookingApproved"
                                ) {
                                  width = "10%";
                                  textAlign = "center";
                                } else if (keyvalue === "totalLocking") {
                                  width = "10%";
                                  textAlign = "center";
                                } else if (
                                  keyvalue ===
                                  "totalLockingApartmentValueApproved"
                                ) {
                                  width = "10%";
                                  textAlign = "center";
                                } else if (keyvalue === "saleAreaCode") {
                                  width = "10%";
                                  textAlign = "start";
                                } else if (keyvalue === "saleAreaName") {
                                  width = "10%";
                                  textAlign = "start";
                                } else if (keyvalue === "saleBlockName") {
                                  width = "10%";
                                  textAlign = "start";
                                } else if (keyvalue === "saleBlockCode") {
                                  width = "10%";
                                  textAlign = "start";
                                } else if (
                                  keyvalue === "totalLockingApproved"
                                ) {
                                  width = "10%";
                                  textAlign = "center";
                                } else if (keyvalue === "totalContract") {
                                  width = "10%";
                                  textAlign = "center";
                                } else if (keyvalue === "totalTtkqAmount") {
                                  width = "10%";
                                  textAlign = "start";
                                } else if (
                                  keyvalue === "totalTtkqAmountApproved"
                                ) {
                                  width = "10%";
                                  textAlign = "start";
                                } else if (keyvalue === "totalContractAmount") {
                                  width = "10%";
                                  textAlign = "start";
                                } else if (
                                  keyvalue === "totalContractAmountApproved"
                                ) {
                                  width = "10%";
                                  textAlign = "start";
                                } else if (
                                  keyvalue === "totalContractApproved"
                                ) {
                                  width = "10%";
                                  textAlign = "center";
                                } else if (keyvalue === "totalTtkq") {
                                  width = "10%";
                                  textAlign = "center";
                                } else if (keyvalue === "totalTtkqApproved") {
                                  width = "10%";
                                  textAlign = "center";
                                } else {
                                  width = "10%";
                                  textAlign = "end";
                                  whiteSpace = "inherit";
                                }

                                const content = (() => {
                                  switch (keyvalue) {
                                    case "totalLockingApproved":
                                      return formatTableValue(
                                        e[keyvalue],
                                        keyvalue,
                                        getLockingStatementUrl,
                                        e?.id,
                                        e?.saleAreaId,
                                        e?.saleBlockId,
                                        "APPROVED",
                                        statementTab
                                      );
                                    case "totalBookingApproved":
                                      return formatTableValue(
                                        e[keyvalue],
                                        keyvalue,
                                        getBookingStatementUrl,
                                        e?.id,
                                        e?.saleAreaId,
                                        e?.saleBlockId,
                                        "APPROVED",
                                        statementTab
                                      );
                                    case "totalContractApproved":
                                      return formatTableValue(
                                        e[keyvalue],
                                        keyvalue,
                                        getSaleContractStatementUrl,
                                        e?.id,
                                        e?.saleAreaId,
                                        e?.saleBlockId,
                                        "APPROVED",
                                        statementTab
                                      );
                                    case "totalTtkqApproved":
                                      return formatTableValue(
                                        e[keyvalue],
                                        keyvalue,
                                        getTtkqStatementUrl,
                                        e?.id,
                                        e?.saleAreaId,
                                        e?.saleBlockId,
                                        "APPROVED",
                                        statementTab
                                      );
                                    // case 1:
                                    //   return formatTableValue(
                                    //     e[keyvalue],
                                    //     keyvalue,
                                    //     onSubmitBooking
                                    //   );
                                    default:
                                      return formatTableValue(
                                        e[keyvalue],
                                        keyvalue
                                      );
                                  }
                                })();
                                return (
                                  <Td
                                    p={"16px 16px 8px 16px"}
                                    w={width}
                                    key={index}
                                  >
                                    <Box
                                      fontSize={{ base: "14px" }}
                                      lineHeight={"19.6px"}
                                      textAlign={"start"}
                                      fontWeight={500}
                                      color={"var(--color-info-employee)"}
                                      w={widthText}
                                      whiteSpace={whiteSpace}
                                      overflow="hidden"
                                      textOverflow="ellipsis"
                                      display="-webkit-box"
                                      sx={{
                                        WebkitLineClamp: "2",
                                        WebkitBoxOrient: "vertical",
                                      }}
                                    >
                                      {content}

                                      {/* {formatTableValue(e[keyvalue], keyvalue)} */}
                                    </Box>
                                  </Td>
                                );
                              })}
                            </Tr>
                          );
                        })
                      ) : (
                        <Tr>
                          <Td
                            colSpan={tableData.headers.length}
                            textAlign="center"
                            padding={"40px 0"}
                          >
                            Không có dữ liệu
                          </Td>
                        </Tr>
                      )}
                    </Tbody>
                  </Table>
                </TableContainer>
              </Skeleton>
              <Box mt={10} mr={5} mb={5} ml={5}>
                <Flex alignItems={"center"} justifyContent={"space-between"}>
                  <Text>
                    Showing {startEntry} to {endEntry} of {entries} entries
                  </Text>
                  <HStack spacing={2} justify="flex-end">
                    <ReactPaginate
                      className="pagination-custom"
                      pageCount={totalPages}
                      pageRangeDisplayed={3}
                      marginPagesDisplayed={1}
                      onPageChange={handlePageChange}
                      containerClassName={"pagination"}
                      activeClassName={"active"}
                      breakClassName={"ellipsis"}
                      breakLabel={"..."}
                      previousLabel={
                        <Img
                          w={"16px"}
                          minW={"16px"}
                          h={"16px"}
                          src={chevronLeft}
                        />
                      }
                      nextLabel={
                        <Img
                          w={"16px"}
                          minW={"16px"}
                          h={"16px"}
                          src={chevronRight}
                        />
                      }
                      renderOnZeroPageCount={null}
                      forcePage={currentPage - 1}
                    />
                  </HStack>
                </Flex>
              </Box>
            </Box>
          </Flex>
        </Box>
        <Box w={"24.66178266%"}>
          <Flex
            backgroundColor="var(--color-main)"
            borderRadius={{ base: "12px" }}
            flexDirection={"column"}
            minH={"80vh"}
          >
            <Box p={"16px 16px 12px 16px"} cursor={"pointer"}>
              <Flex justifyContent={"space-between"}>
                <Text fontSize={"18px"} fontWeight={"600"}>
                  Thống kê
                </Text>
                <Link to={"/statement-detail"}>
                  <Text
                    fontSize={"16px"}
                    color={"var(--color-option-employee-hover)"}
                  >
                    Xem chi tiết
                  </Text>
                </Link>
              </Flex>

              <Box mt={"8px"}>
                <Flex mt={"12px"} gap={"8px"} alignItems={"center"}>
                  <Text fontSize={"16px"} fontWeight={500}>
                    Số booking:
                  </Text>
                  <Text fontSize={"16px"} fontWeight={400}>
                    {getTotalReportData?.totalBooking || 0}
                  </Text>
                </Flex>
                <Flex mt={"12px"} gap={"8px"} alignItems={"center"}>
                  <Text fontSize={"16px"} fontWeight={500}>
                    Số booking đã duyệt:
                  </Text>
                  <Text fontSize={"16px"} fontWeight={400}>
                    {getTotalReportData?.totalBookingApproved || 0}
                  </Text>
                </Flex>
                <Flex mt={"12px"} gap={"8px"} alignItems={"center"}>
                  <Text fontSize={"16px"} fontWeight={500}>
                    Số locking:
                  </Text>
                  <Text fontSize={"16px"} fontWeight={400}>
                    {getTotalReportData?.totalLocking || 0}
                  </Text>
                </Flex>
                <Flex mt={"12px"} gap={"8px"} alignItems={"center"}>
                  <Text fontSize={"16px"} fontWeight={500}>
                    Số locking đã duyệt:
                  </Text>
                  <Text fontSize={"16px"} fontWeight={400}>
                    {getTotalReportData?.totalLockingApproved || 0}
                  </Text>
                </Flex>
                <Flex mt={"12px"} gap={"8px"} alignItems={"center"}>
                  <Text fontSize={"16px"} fontWeight={500}>
                    Doanh số locking đã duyệt:
                  </Text>
                  <Text fontSize={"16px"} fontWeight={400}>
                    {getTotalReportData?.totalLockingApartmentValueApproved
                      ? `${formatNumber(
                          getTotalReportData?.totalLockingApartmentValueApproved
                        )} VNĐ`
                      : "0 VNĐ"}
                  </Text>
                </Flex>
                <Flex mt={"12px"} gap={"8px"} alignItems={"center"}>
                  <Text fontSize={"16px"} fontWeight={500}>
                    Số TTKQ:
                  </Text>
                  <Text fontSize={"16px"} fontWeight={400}>
                    {getTotalReportData?.totalTtkq || 0}
                  </Text>
                </Flex>
                <Flex mt={"12px"} gap={"8px"} alignItems={"center"}>
                  <Text fontSize={"16px"} fontWeight={500}>
                    Số TTKQ đã duyệt:
                  </Text>
                  <Text fontSize={"16px"} fontWeight={400}>
                    {getTotalReportData?.totalTtkqApproved || 0}
                  </Text>
                </Flex>
                <Flex mt={"12px"} gap={"8px"} alignItems={"center"}>
                  <Text fontSize={"16px"} fontWeight={500}>
                    Số HĐMB:
                  </Text>
                  <Text fontSize={"16px"} fontWeight={400}>
                    {getTotalReportData?.totalContract || 0}
                  </Text>
                </Flex>
                <Flex mt={"12px"} gap={"8px"} alignItems={"center"}>
                  <Text fontSize={"16px"} fontWeight={500}>
                    Số HĐMB đã duyệt:
                  </Text>
                  <Text fontSize={"16px"} fontWeight={400}>
                    {getTotalReportData?.totalContractApproved || 0}
                  </Text>
                </Flex>

                {/* <Flex mt={"12px"} gap={"8px"} alignItems={"center"}>
                  <Text fontSize={"16px"} fontWeight={500}>
                    Doanh số booking:
                  </Text>
                  <Text fontSize={"16px"} fontWeight={400}>
                    {getTotalReportData?.totalBookingAmount
                      ? `${formatNumber(
                          getTotalReportData?.totalBookingAmount
                        )} VNĐ`
                      : "0 VNĐ"}
                  </Text>
                </Flex>
                <Flex mt={"12px"} gap={"8px"} alignItems={"center"}>
                  <Text fontSize={"16px"} fontWeight={500}>
                    Doanh số booking đã duyệt:
                  </Text>
                  <Text fontSize={"16px"} fontWeight={400}>
                    {getTotalReportData?.totalBookingAmountApproved
                      ? `${formatNumber(
                          getTotalReportData?.totalBookingAmountApproved
                        )} VNĐ`
                      : "0 VNĐ"}
                  </Text>
                </Flex> */}

                {/* <Flex mt={"12px"} gap={"8px"} alignItems={"center"}>
                  <Text fontSize={"16px"} fontWeight={500}>
                    Doanh số locking:
                  </Text>
                  <Text fontSize={"16px"} fontWeight={400}>
                    {getTotalReportData?.totalLockingAmount
                      ? `${formatNumber(
                          getTotalReportData?.totalLockingAmount
                        )} VNĐ`
                      : "0 VNĐ"}
                  </Text>
                </Flex>
                <Flex mt={"12px"} gap={"8px"} alignItems={"center"}>
                  <Text fontSize={"16px"} fontWeight={500}>
                    Doanh số locking đã duyệt:
                  </Text>
                  <Text fontSize={"16px"} fontWeight={400}>
                    {getTotalReportData?.totalLockingApartmentValueApproved
                      ? `${formatNumber(
                          getTotalReportData?.totalLockingApartmentValueApproved
                        )} VNĐ`
                      : "0 VNĐ"}
                  </Text>
                </Flex> */}

                {/* <Flex mt={"12px"} gap={"8px"} alignItems={"center"}>
                  <Text fontSize={"16px"} fontWeight={500}>
                    Doanh số TTKQ:
                  </Text>
                  <Text fontSize={"16px"} fontWeight={400}>
                    {getTotalReportData?.totalTtkqAmount
                      ? `${formatNumber(
                          getTotalReportData?.totalTtkqAmount
                        )} VNĐ`
                      : "0 VNĐ"}
                  </Text>
                </Flex>
                <Flex mt={"12px"} gap={"8px"} alignItems={"center"}>
                  <Text fontSize={"16px"} fontWeight={500}>
                    Doanh số TTKQ đã duyệt:
                  </Text>
                  <Text fontSize={"16px"} fontWeight={400}>
                    {getTotalReportData?.totalTtkqAmountApproved
                      ? `${formatNumber(
                          getTotalReportData?.totalTtkqAmountApproved
                        )} VNĐ`
                      : "0 VNĐ"}
                  </Text>
                </Flex>

                <Flex mt={"12px"} gap={"8px"} alignItems={"center"}>
                  <Text fontSize={"16px"} fontWeight={500}>
                    Doanh số HĐMB:
                  </Text>
                  <Text fontSize={"16px"} fontWeight={400}>
                    {getTotalReportData?.totalContractAmount
                      ? `${formatNumber(
                          getTotalReportData?.totalContractAmount
                        )} VNĐ`
                      : "0 VNĐ"}
                  </Text>
                </Flex>
                <Flex mt={"12px"} gap={"8px"} alignItems={"center"}>
                  <Text fontSize={"16px"} fontWeight={500}>
                    Doanh số HĐMB đã duyệt:
                  </Text>
                  <Text fontSize={"16px"} fontWeight={400}>
                    {getTotalReportData?.totalContractAmountApproved
                      ? `${formatNumber(
                          getTotalReportData?.totalContractAmountApproved
                        )} VNĐ`
                      : "0 VNĐ"}
                  </Text>
                </Flex> */}
              </Box>
            </Box>
          </Flex>
        </Box>
      </Flex>
    </>
  );
};

export default TableStatement;
